import n, { useCallback as b, useMemo as A } from "react";
import { PaymentAPI as x } from "../../../../js/payments/paymentApi.js";
import { usePaymentMethod as v } from "../hooks/usePaymentMethod.js";
import { PaymentMethod as w } from "../PaymentMethod/PaymentMethod.js";
import l from "./paymentMethodCompound.module.scss.js";
function _({ design: d, texts: s, hideCashback: u = !1 }) {
  const m = v();
  if (!m)
    throw new Error("PaymentMethodCompound should be inside a PaymentMethodContext provider");
  const {
    amount: p,
    isFullCashbackPayment: c,
    isRedirectOnlyPayment: y,
    paymentMethods: r,
    payerId: f,
    activateMethod: h,
    activePaymentMethod: t,
    initializePaymentMethod: a
  } = m;
  function M(e, o) {
    (t == null ? void 0 : t.methodType) === o && (t == null ? void 0 : t.engine) === e || h(e, o);
  }
  const C = b((e) => {
    e !== null && a(e);
  }, [a]), P = A(
    () => r.filter(({ engine: e }) => !(u && e === x.PaymentMethodEngine.CASHBACK)).map(({
      active: e,
      methodType: o,
      engine: i,
      channel: k
    }, E) => /* @__PURE__ */ n.createElement(
      "div",
      {
        className: l.paymentMethodButtonWrapper,
        key: `method-${E}`,
        onClick: () => M(i, o)
      },
      /* @__PURE__ */ n.createElement(
        w,
        {
          method: o,
          engine: i,
          channel: k,
          active: e,
          design: d,
          texts: s
        },
        e && /* @__PURE__ */ n.createElement("div", { ref: C })
      )
    )),
    [r, f]
  );
  return y ? null : /* @__PURE__ */ n.createElement(
    "div",
    {
      className: l.compound,
      style: {
        display: p === 0 || c ? "none" : "block"
      }
    },
    P
  );
}
export {
  _ as PaymentMethodCompound
};
//# sourceMappingURL=PaymentMethodCompound.js.map
